import { render, staticRenderFns } from "./DiagnosticDashboard.vue?vue&type=template&id=b99e5f3a&"
import script from "./DiagnosticDashboard.vue?vue&type=script&lang=js&"
export * from "./DiagnosticDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports